import { render, staticRenderFns } from "./QueryResult.vue?vue&type=template&id=0fe226da&scoped=true"
import script from "./QueryResult.vue?vue&type=script&lang=js"
export * from "./QueryResult.vue?vue&type=script&lang=js"
import style0 from "./QueryResult.vue?vue&type=style&index=0&id=0fe226da&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe226da",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fe226da')) {
      api.createRecord('0fe226da', component.options)
    } else {
      api.reload('0fe226da', component.options)
    }
    module.hot.accept("./QueryResult.vue?vue&type=template&id=0fe226da&scoped=true", function () {
      api.rerender('0fe226da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/back/TalentQuery/ResultPage/QueryResult.vue"
export default component.exports